export default {
      id: "oc-icon_after_shutdown-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "sprite.svg#oc-icon_after_shutdown",
      toString: function () {
        return this.url;
      }
    }